module.exports = __webpack_public_path__ + "img/499577-1.84d0bb53.png";